import "core-js/modules/es.object.define-property";
import { __decorate, __extends } from "tslib";
import { Vue, Component } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
var Common = namespace('common');

var Feedback = function (_super) {
  __extends(Feedback, _super);

  function Feedback() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.faqIsShow = false;
    return _this;
  }

  Object.defineProperty(Feedback.prototype, "defaultRoute", {
    get: function get() {
      return this.$route.path;
    },
    set: function set(value) {
      return value;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Feedback.prototype, "isUnackFlag", {
    get: function get() {
      return !!this.$store.state.common.unReadFeedbackNum;
    },
    enumerable: false,
    configurable: true
  });

  Feedback.prototype.handleTabChange = function (key) {
    this.$router.push(key);
  };

  Feedback.prototype.ackCallback = function () {
    this.queryUnreadFeedbackNum();
  };

  Feedback.prototype.tabChangeFeedback = function () {
    this.defaultRoute = '/help/feedback/list';
  };

  Feedback.prototype.handleFaqChange = function (faqIsShow) {
    this.faqIsShow = faqIsShow;
  };

  __decorate([Common.Action('queryUnreadFeedbackNum')], Feedback.prototype, "queryUnreadFeedbackNum", void 0);

  Feedback = __decorate([Component], Feedback);
  return Feedback;
}(Vue);

export default Feedback;